// extracted by mini-css-extract-plugin
export default {"inline-message":"sign-in-form_inline-message__gR5c6"};